import type { Snippet, Component } from "svelte";

export enum PopoverPosition {
  TOP = "top",
  BOTTOM = "bottom",
}

export type PopoverPositioningResult = {
  anchorLeftPosition: string | false;
  position: `${PopoverPosition}`;
  popoverStyles: Record<string, string>;
};

export type PopoverProps = {
  contextElement?: HTMLElement | null;
  bubble: Component;
  show?: boolean;
  sticky?: boolean;
  preferredPosition?: `${PopoverPosition}`;
  onFullyShown?: () => void;
  children: Snippet;
};
